var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Timeline"},_vm._l((_vm.timeline),function(item,index){return _c('ja-timeline-item',{key:`tl_${index}`,attrs:{"date":item.date,"events":item.events}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }